"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var amazon_config_store_type_script_client_1 = require("@amzn/amazon-config-store-type-script-client");
var AbstractOfflineClientSettings = /** @class */ (function () {
    function AbstractOfflineClientSettings(options) {
        if (options === void 0) { options = {}; }
        var _a;
        this.stage = (_a = options.stage) !== null && _a !== void 0 ? _a : amazon_config_store_type_script_client_1.ClientStage.PROD;
        this.weblabRulesResolver = this.createWeblabRulesResolver(options);
    }
    AbstractOfflineClientSettings.prototype.getStage = function () {
        return this.stage;
    };
    AbstractOfflineClientSettings.prototype.getWeblabRulesResolver = function () {
        return this.weblabRulesResolver;
    };
    return AbstractOfflineClientSettings;
}());
exports.default = AbstractOfflineClientSettings;
